import { createStandAloneSnackbar } from '@saas-ui/react';

import { SnackbarProps } from './Snackbar.types';
import { SnackbarComponent } from './SnackbarComponent';

const MAX_ACTIVE = 6;
const state = ((
  globalThis as typeof globalThis & {
    __vh3Snack?: { active: number; queue: SnackbarProps[] };
  }
).__vh3Snack ??= { active: 0, queue: [] });

const { snackbar: baseSnackbar } = createStandAloneSnackbar({
  colorMode: 'dark',
  defaultOptions: {
    isClosable: true,
    variant: 'solid',
    status: 'info',
    position: 'bottom-left',
    render: SnackbarComponent,
    containerStyle: {
      my: '1.5px',
      mx: '0',
      width: { base: '100vw', md: 'auto' },
      maxW: { base: 'calc(100% - 16px)', md: '400px' },
      alignItems: { base: 'stretch', md: 'flex-start' },
      pointerEvents: 'auto',
    },
  },
});

const show = (props: SnackbarProps) => {
  state.active += 1;
  return baseSnackbar({
    styleConfig: props,
    duration: props.persistent ? 100_000_000 : props.duration,
    position: 'top',
    onCloseComplete: () => {
      state.active = Math.max(0, state.active - 1);
      props.onClose?.();
      const next = state.queue.shift();
      if (next) show(next);
    },
  });
};

export function snackbar(props: SnackbarProps) {
  if (state.active < MAX_ACTIVE) return show(props);
  state.queue.push(props);
  return undefined;
}
